<template>
    <div class="paginator flex-align-center" v-if="totalPages > 0">
        <div class="paginator__records flex-align-center">
            <div class="records__label">
                {{ $t('paginator.recordsLabel') }}
            </div>
            <md-field style="width: 70px">
                <md-select v-model="currentPageSize" @md-selected="onPageSizeChange" md-dense class="no-border">
                    <md-option v-for="(size, index) in pageSizeOptions" :value="size" :key="index">{{ size }}</md-option>
                </md-select>
            </md-field>
        </div>
        <div class="paginator__navigation flex-align-center">
            <md-button @click="changePage(1)" class="md-icon-button" :disabled="currentPage === 1">
                <md-icon>first_page</md-icon>
            </md-button>
            <md-button @click="changePage(currentPage - 1)" class="md-icon-button" :disabled="currentPage === 1">
                <md-icon>chevron_left</md-icon>
            </md-button>

            <div v-if="totalPages < 6 && showPageNumbers" class="flex-align-center">
                <md-button v-for="n in totalPages" :key="n" @click="changePage(n)" class="md-icon-button"
                    :class="isCurrentPage(n) ? 'md-accent' : ''">
                    {{ n }}
                </md-button>
            </div>

            <div v-else-if="currentPage >= 3 && totalPages - currentPage >= 3 && showPageNumbers" class="flex-align-center">
                <md-button v-for="n in 5" :key="n" @click="changePage(n + currentPage - 3)" class="md-icon-button"
                    :class="isCurrentPage(n + currentPage - 3) ? 'md-accent' : ''">
                    {{ n + currentPage - 3 }}
                </md-button>
            </div>

            <div v-else-if="currentPage < 3 && showPageNumbers" class="flex-align-center">
                <md-button v-for="n in 5" :key="n" @click="changePage(n)" class="md-icon-button"
                    :class="isCurrentPage(n) ? 'md-accent' : ''">
                    {{ n }}
                </md-button>
            </div>

            <div v-else-if="currentPage >= 3 && totalPages - currentPage < 3 && showPageNumbers" class="flex-align-center">
                <md-button v-for="n in 5" :key="n" @click="changePage(totalPages - 5 + n)" class="md-icon-button"
                        :class="isCurrentPage(totalPages - 5 + n) ? 'md-accent' : ''">
                    {{ totalPages - 5 + n }}
                </md-button>
            </div>

            <div v-else-if="!showPageNumbers">
                <md-button class="md-icon-button md-primary">
                    {{ currentPage }}
                </md-button>
            </div>

            <md-button @click="changePage(currentPage + 1)" class="md-icon-button"
                    :disabled="currentPage === totalPages || totalPages === 0">
                <md-icon>chevron_right</md-icon>
            </md-button>
            <md-button v-if="showPageNumbers" @click="changePage(totalPages)" class="md-icon-button"
                    :disabled="currentPage === totalPages || totalPages === 0">
                <md-icon>last_page</md-icon>
            </md-button>
            <span v-if="showPageNumbers" class="md-caption">{{ (currentPage - 1) * currentPageSize + 1 }} - {{ Math.min(currentPage * currentPageSize, length) }} / {{ length }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Paginator",
        props: {
            page: {
                type: Number,
                default: 1
            },
            pageSize: {
                type: Number,
                default: 0
            },
            pageSizeOptions: {
                type: Array,
                default: () => [10, 25, 50, 100]
            },
            length: {
                type: Number,
                default: 0,
                required: true
            },
            showPageNumbers: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            totalPages: {
                get() {
                    return Math.ceil(this.length / this.currentPageSize);
                }
            }
        },
        created() {
            if (this.pageSize === 0) {
                this.currentPageSize = this.pageSizeOptions[0];
            }
        },
        data: () => ({
            currentPage: 0,
            currentPageSize: 0
        }),
        watch: {
            page: {
                immediate: true,
                handler: function (newVal) {
                    this.currentPage = newVal;
                }
            },
            pageSize: {
                immediate: true,
                handler: function (newVal) {
                    this.currentPageSize = newVal;
                }
            }
        },
        methods: {
            isCurrentPage(n) {
                return this.page === n;
            },
            changePage(page) {
                if (page > 0 && page <= this.totalPages && !this.isCurrentPage(page)) {
                    this.$emit('update:page', page);
                    this.$emit('pageChange', page);
                }
            },
            onPageSizeChange(newSize) {
                this.currentPage = 1;
                this.$emit('update:page', this.currentPage);
                this.$emit('update:pageSize', newSize);
                this.$emit('pageChange', this.currentPage);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .flex-align-center {
        display: flex;
        align-items: center;
    }

    .paginator {
        width: 100%;
        height: 40px;
        margin-top: 20px;
        justify-content: space-between;
    }

    .paginator__records {
        height: 100%;
    }

    .records__label {
        font-size: 13px;
        margin-right: 20px;
    }
</style>
